import { InfoBox } from '@selina-finance/ui';

const ErrorContainer = (props: {
    formikProps: any;
    additionalErrors?: string[];
}) => {
    const getNumberOfErrors = (formikProps: any): number => {
        const countErrors = (errors: any, touched: any): number => {
            let count = 0;

            for (const key in errors) {
                if (!Object.prototype.hasOwnProperty.call(errors, key))
                    continue;

                const errorVal = errors[key];
                const touchedVal = touched?.[key];

                if (typeof errorVal === 'string' && touchedVal) {
                    count++;
                } else if (
                    typeof errorVal === 'object' &&
                    errorVal !== null &&
                    touchedVal
                ) {
                    count += countErrors(errorVal, touchedVal);
                }
            }

            return count;
        };

        return countErrors(formikProps.errors, formikProps.touched);
    };

    const errorLength = getNumberOfErrors(props.formikProps);

    return errorLength > 0 ? (
        <div className='mb-3'>
            <InfoBox type='error'>
                There{' '}
                {errorLength > 1
                    ? 'are ' + errorLength + ' errors'
                    : 'is 1 error'}{' '}
                on this page, &nbsp;please resolve to continue
                <ul className='ml-6 list-disc'>
                    {props.additionalErrors &&
                        props.additionalErrors.map((it, index) =>
                            it ? <li key={index}>{it}</li> : null,
                        )}
                </ul>
            </InfoBox>
        </div>
    ) : (
        <></>
    );
};

export default ErrorContainer;
